var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex px-5 py-3 container justify-content-center flex-column",
    },
    [
      _vm.complete
        ? _c(
            "div",
            { staticClass: "d-flex gap-50" },
            [
              _c("div", { staticClass: "bg-white p-3 w-25" }, [
                _c("img", {
                  staticClass: "img-fluid m-0 diff-img",
                  attrs: { src: this.dataSet1.uri },
                }),
              ]),
              _vm._v(" "),
              _vm.currentJob.state === "completed"
                ? _c("meta-data-table", {
                    attrs: {
                      "first-file": _vm.currentJob.apiJob?.input[0],
                      "second-file": _vm.currentJob.apiJob?.input[1],
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.factors !== null
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("ImageQualityFactorTable", {
                attrs: {
                  percentDiff: _vm.percentDiff,
                  factors: this.factors,
                  response: this.response,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }